// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment_icon__ZTBTH {
  margin-left: 7px;
  font-size: 16px;
}

.Payment_body__EbFWI {
  display: flex;
  justify-content: space-between;
}
.Payment_body__EbFWI .Payment_payment-steps__8QkZe {
  width: 62%;
}
.Payment_body__EbFWI .Payment_payment-steps__8QkZe .Payment_question__iGYGz {
  font-size: 12px;
}

.Payment_tooltip-text__W\\+PAo {
  width: 230px;
  height: 80px;
  margin-left: 20px;
}
.Payment_tooltip-text__W\\+PAo .Payment_copy-email__BRhta {
  color: #054ab0;
  font-size: 16px;
}

.Payment_payment-container__oWHiy {
  display: flex;
}

.Payment_payment-box__fvWI1 {
  margin-left: 3%;
}

@media (min-width: 1300px) {
  .Payment_medium-subtitle__gHH\\+z {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/Payment.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,eCFO;ADCT;;AAIA;EACE,aAAA;EACA,8BAAA;AADF;AAEE;EACE,UAAA;AAAJ;AACI;EACE,eCbG;ADcT;;AAIA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AADF;AAEE;EACE,cErBK;EFsBL,eCtBK;ADsBT;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE;IACE,eCjCO;EDgCT;AACF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n.icon {\n  margin-left: 7px;\n  font-size: typography.$body-l;\n}\n\n.body {\n  display: flex;\n  justify-content: space-between;\n  .payment-steps {\n    width: 62%;\n    .question {\n      font-size: typography.$body-s;\n    }\n  }\n}\n\n.tooltip-text {\n  width: 230px;\n  height: 80px;\n  margin-left: 20px;\n  .copy-email {\n    color: colors.$accent;\n    font-size: typography.$body-l;\n  }\n}\n\n.payment-container {\n  display: flex;\n}\n\n.payment-box {\n  margin-left: 3%;\n}\n\n@media (min-width: 1300px) {\n  .medium-subtitle {\n    font-size: typography.$header-m;\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Payment_icon__ZTBTH`,
	"body": `Payment_body__EbFWI`,
	"payment-steps": `Payment_payment-steps__8QkZe`,
	"question": `Payment_question__iGYGz`,
	"tooltip-text": `Payment_tooltip-text__W+PAo`,
	"copy-email": `Payment_copy-email__BRhta`,
	"payment-container": `Payment_payment-container__oWHiy`,
	"payment-box": `Payment_payment-box__fvWI1`,
	"medium-subtitle": `Payment_medium-subtitle__gHH+z`
};
export default ___CSS_LOADER_EXPORT___;
